export default "__VITE_ASSET__B11Ks59a__"